import Mango from "./mango/index.js";
import Chipo from "./chipo/index.js";
import PetrolCard from "./petrolcard/index.js";

export default {
  Mango,
  Chipo,
  PetrolCard,
};
